import React, { useState } from "react";

// Template 1 modal images
const template1_1 = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/template1.png";
const template1_2 = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/template2.png";
const template1_3 = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/template3.png";

// Template 2 modal images
const client1 = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/clienttemplate1.png";
const client2 = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/clienttemplate12.png";

// Template 3 modal images
const card10 = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/card10.png";
const card11 = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/card11.png";
const card12 = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/card12.png";

// Template 4 modal images
const card20 = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/card20.png";
const card21 = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/card21.png";
const card22 = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/card22.png";

// Canva image
const canva = "https://pub-b515366b2bdd4fb696b694c901df278b.r2.dev/images/canva.png";

export default function FreeDownloads() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [modalImages, setModalImages] = useState([]);

  const templates = [
    {
      image: canva,
      title: "Client Welcome Packet",
      desc: "Professional packet to onboard clients seamlessly.",
      link: "https://drive.google.com/drive/folders/1mczRNlhmKmGKeRtgTSObpc7dqC4v6Dv5?usp=sharing",
      modalImages: [template1_1, template1_2, template1_3],
    },
    {
      image: client1,
      title: "Client Service Description Template",
      desc: "Clearly outline your services for clients in a professional template.",
      link: "https://drive.google.com/drive/folders/1SIgHTGzMsLvGyp43YDJG3QrcZg1Pftat?usp=sharing",
      modalImages: [client1, client2],
    },
    {
      image: card10,
      title: "Online Business Card Canva",
      desc: "Digital business card templates for professional branding.",
      link: "https://drive.google.com/file/d/1l9AJYNi6Lg4O-PLe1MZ-tietD2Obd237/view?usp=sharing",
      modalImages: [card10, card11, card12],
    },
    {
      image: card20,
      title: "Online Business Card Template",
      desc: "Another stylish digital business card template for professionals.",
      link: "https://drive.google.com/file/d/1aWq-kzCNYFXuzk9EvIrOj8pE6S6LiN_I/view?usp=sharing",
      modalImages: [card20, card21, card22],
    },
  ];

  const openModal = (template) => {
    setModalImages(template.modalImages);
    setCurrentIndex(0);
    setIsModalOpen(true);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? modalImages.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === modalImages.length - 1 ? 0 : prev + 1));
  };

  return (
    <div style={styles.page}>
      {/* Heading Section */}
      <div style={{ marginBottom: "50px" }}>
        <h1 style={styles.heading}>Free Downloads</h1>
        <p style={styles.subText}>
          Explore our collection of professionally designed templates crafted to
          save you time and elevate your brand presence.
        </p>
      </div>

      {/* Grid Layout */}
      <div style={styles.grid}>
        {templates.map((template, index) => (
          <div key={index} style={styles.card}>
            <img
              src={template.image}
              alt={template.title}
              style={styles.image}
              onClick={() => openModal(template)}
            />
            <h2 style={styles.title}>{template.title}</h2>
            <p style={styles.description}>{template.desc}</p>
            <a
              href={template.link}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.button}
            >
              Download Now
            </a>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div style={styles.modalOverlay} onClick={() => setIsModalOpen(false)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button
              style={styles.closeButton}
              onClick={() => setIsModalOpen(false)}
            >
              ×
            </button>

            <img
              src={modalImages[currentIndex]}
              alt="Template Preview"
              style={styles.modalImage}
            />

            {modalImages.length > 1 && (
              <>
                <button style={styles.prevButton} onClick={handlePrev}>
                  &#8592;
                </button>
                <button style={styles.nextButton} onClick={handleNext}>
                  &#8594;
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// ✅ Styles
const styles = {
  page: {
    padding: "60px 20px",
    textAlign: "center",
    background: "#121723",
    minHeight: "100vh",
    fontFamily: "Elza, sans-serif",
    color: "#fff",
  },
  heading: {
    fontSize: "52px",
    marginBottom: "20px",
    color: "#fff",
    textAlign: "center",
    fontWeight: 800,
    letterSpacing: "-0.8px",
  },
  subText: {
    fontSize: "18px",
    color: "#cfd2da",
    lineHeight: "1.6",
    maxWidth: "720px",
    margin: "0 auto 6px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: "28px",
    maxWidth: "1100px",
    margin: "0 auto",
  },
  card: {
    background: "rgba(255, 255, 255, 0.05)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    borderRadius: "14px",
    padding: "18px",
    textAlign: "center",
    boxShadow: "0 6px 16px rgba(0,0,0,0.3)",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    cursor: "pointer",
  },
  image: {
    width: "100%",
    borderRadius: "10px",
    marginBottom: "14px",
  },
  title: {
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: "6px",
    color: "#fff",
    letterSpacing: "-0.2px",
  },
  description: {
    fontSize: "14px",
    marginBottom: "12px",
    color: "#ccc",
    lineHeight: "1.4",
    fontWeight: 400,
  },
  button: {
    background: "#7b19bc",
    color: "#fff",
    padding: "10px 24px",
    borderRadius: "0px",
    textDecoration: "none",
    fontWeight: 600,
    display: "inline-block",
    transition: "background 0.3s ease",
    fontSize: "15px",
    letterSpacing: "-0.2px",
    border: "none",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 999,
  },
  modalContent: {
    position: "relative",
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    maxWidth: "800px",
    width: "90%",
    textAlign: "center",
  },
  modalImage: {
    width: "100%",
    borderRadius: "8px",
    marginBottom: "15px",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "15px",
    fontSize: "28px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#333",
  },
  prevButton: {
    position: "absolute",
    top: "50%",
    left: "10px",
    transform: "translateY(-50%)",
    fontSize: "28px",
    background: "rgba(0,0,0,0.5)",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    padding: "8px",
    cursor: "pointer",
  },
  nextButton: {
    position: "absolute",
    top: "50%",
    right: "10px",
    transform: "translateY(-50%)",
    fontSize: "28px",
    background: "rgba(0,0,0,0.5)",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    padding: "8px",
    cursor: "pointer",
  },
};
